module.exports = __webpack_public_path__ + "herb-garden-2.jpg?f149b2f8cf12f8b9515cfba3ccc54210";


//////////////////
// WEBPACK FOOTER
// ./src/images/herb-garden-2.jpg
// module id = 82
// module chunks = 0